import { Controller } from "@hotwired/stimulus"
import {
  createIcons,
  Building2,
  Menu,
  MapPin,
  Receipt,
  Building,
  Landmark,
  Cloud,
  CircleQuestionMark,
  CircleDollarSign,
  Heart,
  Gauge,
  Zap,
  ChevronRight,
  ArrowLeft,
  ArrowRight,
  Search,
  Database,
  Shield,
  Globe,
  Code,
  Clock,
  Activity,
  Check,
  Map,
  Braces,
  Mail,
  FileCode
} from "lucide"

const icons = { Building2, Menu, MapPin, Receipt, Building, Landmark, Cloud, CircleQuestionMark, CircleDollarSign, Heart, Gauge, Zap, ChevronRight, ArrowLeft, ArrowRight, Search, Database, Shield, Globe, Code, Clock, Activity, Check, Map, Braces, Mail, FileCode }

export default class extends Controller {
  connect() {
    createIcons({ icons, nameAttr: "data-lucide", root: this.element })
  }
}
